import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface AlsVorlageDialogData {
  listeName: string;
  spaltenCount: number;
  kennzeichnung: string;
}

export interface AlsVorlageDialogErgebnis {
  name: string;
  beschreibung: string | null;
}


/**
 * Struktur einer bestehenden manuellen Liste als Vorlage speichern: fragt
 * nur Namen und Beschreibung ab. Übernommen wird allein die Struktur – keine
 * Messstellen, keine Prüfergebnisse.
 */
@Component({
  selector: 'app-als-vorlage-dialog',
  template: `
    <h2 mat-dialog-title>Struktur als Vorlage speichern</h2>

    <mat-dialog-content>
      <p class="hinweis">
        Übernommen wird die Spaltenstruktur der Liste <strong>{{ data.listeName }}</strong>
        ({{ data.spaltenCount }} Spalte{{ data.spaltenCount === 1 ? '' : 'n' }}, Kennzeichnung: {{ data.kennzeichnung }}).
        Messstellen und Prüfergebnisse gehören nicht zur Vorlage.
      </p>

      <mat-form-field appearance="outline" class="feld">
        <mat-label>Vorlagenname</mat-label>
        <input matInput cdkFocusInitial [(ngModel)]="name" maxlength="200" required
          placeholder="z. B. Standard Messstellen KKS">
      </mat-form-field>

      <mat-form-field appearance="outline" class="feld">
        <mat-label>Beschreibung (optional)</mat-label>
        <input matInput [(ngModel)]="beschreibung" maxlength="1000" placeholder="Wofür eignet sich diese Struktur?">
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
      <button mat-raised-button color="primary" type="button" (click)="speichern()" [disabled]="!name.trim()">
        <mat-icon>bookmark_add</mat-icon>
        Vorlage speichern
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { width: 460px; max-width: 100%; }
    .hinweis { margin: 0 0 var(--space-3); font-size: var(--fs-base); line-height: 1.5; color: var(--text-secondary); }
    .feld { width: 100%; }
  `]
})
export class AlsVorlageDialogComponent {

  name: string;
  beschreibung = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlsVorlageDialogData,
    private dialogRef: MatDialogRef<AlsVorlageDialogComponent, AlsVorlageDialogErgebnis | null>
  ) {
    this.name = data.listeName;
  }

  speichern(): void {
    if (!this.name.trim()) {
      return;
    }

    this.dialogRef.close({
      name: this.name.trim(),
      beschreibung: this.beschreibung.trim() || null
    });
  }

  abbrechen(): void {
    this.dialogRef.close(null);
  }
}
